import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import moment from 'moment';

import {
  fetchInventory,
  fetchInventorySuccess,
  fetchInventoryFailure,
  deleteInventory,
  deleteInventorySuccess,
  deleteInventoryFailure,
  updateInventory,
  updateInventorySuccess,
  updateInventoryFailure,
  createTemperature,
  createTemperatureSuccess,
  createTemperatureFailure,
  addTemperatureToInventory,
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
  fetchWasteCategories,
  fetchWasteCategoriesSuccess,
  fetchWasteCategoriesFailure,
} from "../../store/inventories/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";

import { getItems } from "../../store/inventories/api";

import Alert from '../../utils/Alert';
import Spinner from '../../components/generics/Spinner';
import InventoryDetailHeader from '../../components/inventories/InventoryDetailHeader'
import InventoryHistory from '../../components/inventories/InventoryHistory'
import InventoryShowEdit from '../../components/inventories/InventoryShowEdit'
import InventoryAddTemperature from '../../components/inventories/InventoryAddTemperature'
import InventoryNotFound from '../../components/inventories/InventoryNotFound'
import { withRouter } from "utils/WithRouter";

export class InventoryDetailContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      temperature: '',
      editMode: false,
      isLoadingSearch: false,
      editInventory: {
        grade: undefined,
        grade_index: -1,
        brand: undefined,
        brand_index: -1,
        station: undefined,
        station_index: -1,
        weight: undefined,
        price: undefined,
        packing_date: undefined,
        item: undefined
      },
      errors: []
    }
    this.alertRef = React.createRef();

    this.loadSearchOptions = debounce(this.searchItems, 400);
  }

  componentDidMount() {
    this.props.fetchInventory(this.props.match.params.id);
    this.props.fetchStations();
    this.props.fetchBrands();
    this.props.fetchGrades();
    this.props.fetchWasteCategories();
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.inventoryDetail.loading || prevProps.stationsList.loading ||
          prevProps.gradesList.loading || prevProps.brandsList.loading) &&
        (!this.props.inventoryDetail.loading && !this.props.stationsList.loading &&
          !this.props.gradesList.loading && !this.props.brandsList.loading) ) {

      let brand_index = -1;
      let station_index = -1;
      let grade_index = -1;

      if (this.props.inventoryDetail.inventory.brand) {
        brand_index = this.props.brandsList.brands.results.findIndex((brand) => (
          brand.id === this.props.inventoryDetail.inventory.brand.id
        ));
      }
      if (this.props.inventoryDetail.inventory.station) {
        station_index = this.props.stationsList.stations.results.findIndex((station) => (
          station.id === this.props.inventoryDetail.inventory.station.id
        ));
      }
      if (this.props.inventoryDetail.inventory.extra_info && this.props.inventoryDetail.inventory.extra_info.grade) {
        grade_index = this.props.gradesList.grades.results.findIndex((grade) => (
          grade.grade === this.props.inventoryDetail.inventory.extra_info.grade.grade
        ));
      }

      const selected_value = this.props.inventoryDetail.inventory.item ? this.props.inventoryDetail.inventory.item.id : undefined
      const selected_label = this.props.inventoryDetail.inventory.item ? this.props.inventoryDetail.inventory.item.name : undefined

      this.setState({
        temperature: '',
        editMode: false,
        editInventory: {
          grade: undefined,
          grade_index: grade_index,
          brand: undefined,
          brand_index: brand_index,
          station: undefined,
          station_index: station_index,
          weight: this.props.inventoryDetail.inventory.weight,
          price: this.props.inventoryDetail.inventory.price,
          packing_date: this.props.inventoryDetail.inventory.packing_date,
          selectedItem: {
            value: selected_value,
            label: selected_label,
          },
        },
        errors: []
      });
    }
  }

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1)
    }
    return errors
  };

  handlePackingDateChange = (event) => {
    let editInventory = this.state.editInventory;
    editInventory.packing_date = event.target.value;
    this.setState({editInventory});
  };

  handlePriceChange =  (event) => {
    let editInventory = this.state.editInventory;
    editInventory.price = event.target.value;
    var errors = this.spliceError('price');
    this.setState({editInventory, errors});
  };

  handleWeightChange = (event) => {
    let editInventory = this.state.editInventory;
    editInventory.weight = event.target.value;
    var errors = this.spliceError('weight');
    this.setState({editInventory, errors});
  };

  handleStationChange = (event) => {
    let editInventory = this.state.editInventory;
    editInventory.station = this.props.stationsList.stations.results[event.target.value];
    editInventory.station_index = event.target.value;
    var errors = this.spliceError('station');
    this.setState({editInventory, errors});
  };

  handleBrandChange = (event) => {
    let editInventory = this.state.editInventory;
    editInventory.brand = this.props.brandsList.brands.results[event.target.value];
    editInventory.brand_index = event.target.value;
    var errors = this.spliceError('brand');
    this.setState({editInventory, errors});
  }

  handleGradeChange = (event) => {
    let editInventory = this.state.editInventory;
    editInventory.grade = this.props.gradesList.grades.results[event.target.value];
    editInventory.grade_index = event.target.value;
    this.setState({ editInventory });
  };

  onInventoryDelete = (inventoryId, deleteMessage, waste_category) => {
    var data = new FormData();
    if (deleteMessage) { data.append('delete_message', deleteMessage); }
    if (waste_category) { data.append('waste_category', waste_category); }
    this.props.deleteInventory(inventoryId, this.props, data, this.alertRef);
  };

  onTemperatureChange = (event) => {
    let temperature = event.target.value
    this.setState( { temperature })
  };

  onTemperatureAdd = () => {
    if (this.state.temperature) {
      var data = new FormData();
      data.append('inventory', this.props.inventoryDetail.inventory.id)
      data.append('value', this.state.temperature)
      this.props.createTemperature(data, this.alertRef);
      this.setState( { temperature: '' })
    } else {
      this.alertRef.current.sendAlert("Temperature cannot be blank");
    }
  };

  onSearchChange = (item) => {
    let editInventory = this.state.editInventory;
    editInventory.item = item ? item.value : undefined;
    this.setState({editInventory, selectedItem: item});
  };

  searchItems = (input, callback) => {
    this.setState({isLoadingItems: true});
    let options = [];
    getItems(input).then((res) => {
      res.data.results.map((item) => {
        options.push({value:item.id, label:item.name});
        return true;
      });
      callback(options);
      this.setState({isLoadingItems: false, selectedItem: this.state.selectedItem});
    }).catch((err) => {
      this.setState({isLoadingItems: false});
    });
  };

  switchEditMode = () => {
    let editMode = !this.state.editMode;
    if (!editMode) {
      // Discard changes in editInventory:
      let brand_index = -1
      let station_index = -1
      let grade_index = -1

      if (this.props.inventoryDetail.inventory.brand) {
        brand_index = this.props.brandsList.brands.results.findIndex(brand => brand.id === this.props.inventoryDetail.inventory.brand.id);
      }
      if (this.props.inventoryDetail.inventory.station) {
        station_index = this.props.stationsList.stations.results.findIndex(station => station.id === this.props.inventoryDetail.inventory.station.id);
      }
      if (this.props.inventoryDetail.inventory.extra_info && this.props.inventoryDetail.inventory.extra_info.grade) {
        grade_index = this.props.gradesList.grades.results.findIndex(grade => grade.grade === this.props.inventoryDetail.inventory.extra_info.grade.grade);
      }

      let editInventory = {
        grade: undefined,
        grade_index: grade_index,
        brand: undefined,
        brand_index: brand_index,
        station: undefined,
        station_index: station_index,
        weight: this.props.inventoryDetail.inventory.weight,
        price: this.props.inventoryDetail.inventory.price,
        packing_date: this.props.inventoryDetail.inventory.packing_date,
        selectedItem: undefined,
      };

      this.setState({ editMode, editInventory, errors: [] });
    } else {
      this.setState({ editMode });
    }
  };

  allFieldsGiven = (currentInventory, editInventory) => {
    let errors = this.state.errors.slice();
    let index;

    if (editInventory.station_index === -1 && !currentInventory.station) {
      index = errors.indexOf('station');
      if (index === -1){
        errors.push('station');
      }
    }
    if (editInventory.brand_index === -1 && !currentInventory.brand) {
      index = errors.indexOf('brand');
      if (index === -1){
        errors.push('brand');
      }
    }
    if (editInventory.weight === '') {
      index = errors.indexOf('weight');
      if (index === -1){
        errors.push('weight');
      }
    }
    if (editInventory.price === '') {
      index = errors.indexOf('price');
      if (index === -1){
        errors.push('price');
      }
    }
    this.setState({errors});
    return errors.length === 0;
  };

  saveEditChanges = () => {
    var data = {};
    let currentInventory = this.props.inventoryDetail.inventory
    let editInventory = this.state.editInventory;
    if (this.allFieldsGiven(currentInventory, editInventory)) {
      data.id = currentInventory.id;
      data.station = editInventory.station ? editInventory.station.id : currentInventory.station.id;
      data.brand = editInventory.brand ? editInventory.brand.id : (currentInventory.brand ? currentInventory.brand.id : undefined);
      data.extra_info = editInventory.grade ? { ...{ 'grade': editInventory.grade } }: currentInventory.extra_info
      data.weight = editInventory.weight;
      data.price = editInventory.price;
      data.packing_date = editInventory.packing_date ? moment(editInventory.packing_date).format('YYYY-MM-DD') : '';
      data.item = editInventory.item !== undefined ? editInventory.item : currentInventory.item.id;
      this.props.updateInventory(currentInventory.id, data, this.props, this.alertRef);
      this.setState({ editMode: false });
    } else {
      this.alertRef.current.sendAlert('All fields are required!')
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (this.props.inventoryDetail.loading || !this.props.inventoryDetail.inventory) {
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      );
    } else
        if (this.props.inventoryDetail.inventory.length === 0) {
          return (
            <div>
              <Alert ref={this.alertRef}/>
              <InventoryNotFound id={this.props.match.params.id}/>
            </div>
          );
        } else {
            return (
              <div>
                <Alert ref={this.alertRef}/>
                <div className="card">
                  <InventoryDetailHeader
                    inventory={this.props.inventoryDetail.inventory}
                    onInventoryDelete={this.onInventoryDelete}
                    switchEditMode={this.switchEditMode}
                    saveEditChanges={this.saveEditChanges}
                    editMode={this.state.editMode}
                    allowDelete={this.props.currentUser.user.is_superuser}
                    wasteCategoriesList={this.props.wasteCategoriesList.categories}/>

                  <InventoryShowEdit
                    editMode={this.state.editMode}
                    editInventory={this.state.editInventory}
                    inventory={this.props.inventoryDetail.inventory}

                    stationsList={this.props.stationsList.stations.results}
                    brandsList={this.props.brandsList.brands.results}
                    gradesList={this.props.gradesList.grades.results}

                    onPackingDateChange={this.handlePackingDateChange}
                    onPriceChange={this.handlePriceChange}
                    onWeightChange={this.handleWeightChange}

                    onGradeChange={this.handleGradeChange}
                    onStationChange={this.handleStationChange}
                    onBrandChange={this.handleBrandChange}

                    itemSearch={this.loadSearchOptions}
                    itemIsLoadingSearch={this.state.isLoadingItems}
                    onItemChange={this.onSearchChange}
                    selectedItem={this.state.selectedItem}
                    placeholderItem={this.props.inventoryDetail.inventory.item.name}

                    errors={this.state.errors}
                    />
                </div>

                <InventoryAddTemperature
                  canAddTemperature={this.props.inventoryDetail.inventory.active}
                  temperature={this.state.temperature}
                  onTemperatureChange={this.onTemperatureChange}
                  onTemperatureAdd={this.onTemperatureAdd}/>

                <InventoryHistory inventory={this.props.inventoryDetail.inventory} history={this.props.history}/>
              </div>
            )
        }
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryDetail: state.inventories.inventoryDetail,
    stationsList: state.sessions.stationsList,
    brandsList: state.inventories.brandsList,
    gradesList: state.inventories.gradesList,
    currentUser: state.auth.currentUser,
    wasteCategoriesList: state.inventories.wasteCategoriesList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventory: (iId) => {
      dispatch(fetchInventory(iId)).payload.then((response) => {
        dispatch(fetchInventorySuccess(response.data))
      }, (error) => {
        dispatch(fetchInventoryFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchBrands: () => {
      dispatch(fetchBrands()).payload.then((response) => {
        dispatch(fetchBrandsSuccess(response.data))
      }, (error) => {
        dispatch(fetchBrandsFailure(error));
      });
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then((response) => {
        dispatch(fetchGradesSuccess(response.data))
      }, (error) => {
        dispatch(fetchGradesFailure(error));
      });
    },
    deleteInventory: (id, props, data, alertRef) => {
      dispatch(deleteInventory(id, data)).payload.then((response) => {
        alertRef.current.sendAlert(
          `Inventory ${id} successfully deleted`,
          "success"
        );
        dispatch(deleteInventorySuccess(response.data));
        props.fetchInventory(response.data.id)
      }, (error) => {
        alertRef.current.sendAlert(`Cannot delete Inventory ${id}`);
        dispatch(deleteInventoryFailure(error));
      });
    },
    createTemperature: (data, alertRef) => {
      dispatch(createTemperature(data)).payload.then((response) => {
        alertRef.current.sendAlert("Temperature successfully added!", "success");
        dispatch(addTemperatureToInventory(response.data))
        dispatch(createTemperatureSuccess(response.data))
      }, (error) => {
        alertRef.current.sendAlert("Temperature couldn't be added");
        dispatch(createTemperatureFailure(error));
      });
    },
    updateInventory: (id, data, props, alertRef) => {
      dispatch(updateInventory(id, data)).payload.then((response) => {
        alertRef.current.sendAlert("Inventory successfully modified!", "success");
        props.fetchInventory(response.data.id)
        dispatch(updateInventorySuccess(response.data))
      }, (error) => {
        dispatch(updateInventoryFailure(error))
        alertRef.current.sendAlert('Something went wrong! All fields are required');
        props.fetchInventory(id)
      })
    },
    fetchWasteCategories: () => {
      dispatch(fetchWasteCategories()).payload.then((response) => {
        dispatch(fetchWasteCategoriesSuccess(response.data))
      }, (error) => {
        dispatch(fetchWasteCategoriesFailure(error));
      });
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryDetailContainer));
